import { MushroomOutlineIcon } from './MushroomOutlineIcon';

/**
 * author: Chris Thron
 * id D6C17EB7-0A54-4ECA-81AA-86311E311934
 * name mushroom-outline
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mushroom-outline.svg
 * tags
 * - Nature 
 * - Food / Drink 
 * - Agriculture 
 */
export const FungusOutlineIcon = MushroomOutlineIcon;
export default FungusOutlineIcon